import { bus } from "@App/domain/bus";
import { EventType } from "@App/domain/events";
import { analytics } from "@App/utils/analytics/index";
import { EventLevel } from "@App/utils/analytics/interfaces";

bus.subscribe(EventType.GEOLOCATION_REQUESTED, ({ type, organization, origin }) => {
  analytics.capture({
    name: type,
    level: EventLevel.INFO,
    props: {
      organization: {
        id: organization.id,
        slug: organization.slug,
        name: organization.name,
      },
      origin: origin,
    },
  });
});

bus.subscribe(EventType.GEOLOCATION_GRANTED, ({ type, organization, origin }) => {
  analytics.capture({
    name: type,
    level: EventLevel.INFO,
    props: {
      organization: {
        id: organization.id,
        slug: organization.slug,
        name: organization.name,
      },
      origin: origin,
    },
  });
});

bus.subscribe(EventType.GEOLOCATION_DENIED, ({ type, organization, origin }) => {
  analytics.capture({
    name: type,
    level: EventLevel.INFO,
    props: {
      organization: {
        id: organization.id,
        slug: organization.slug,
        name: organization.name,
      },
      origin: origin,
    },
  });
});

bus.subscribe(EventType.GEOLOCATION_COMPLETED, ({ type, organization, origin }) => {
  analytics.capture({
    name: type,
    level: EventLevel.INFO,
    props: {
      organization: {
        id: organization.id,
        slug: organization.slug,
        name: organization.name,
      },
      origin: origin,
    },
  });
});

bus.subscribe(EventType.GEOLOCATION_FAILED, ({ type, organization, origin, err }) => {
  analytics.capture({
    name: type,
    level: EventLevel.ERROR,
    props: {
      organization: {
        id: organization.id,
        slug: organization.slug,
        name: organization.name,
      },
      origin: origin,
      err: err,
    },
  });
});

bus.subscribe(
  EventType.BOOKING_NO_SLOTS_SHOWN,
  ({ type, organization_id, garage_id, service_id }) => {
    analytics.capture({
      name: type,
      level: EventLevel.INFO,
      props: { organization_id, garage_id, service_id },
    });
  },
);

bus.subscribe(
  EventType.BOOKING_NEAREST_SLOT_GONE_SHOWN,
  ({
    type,
    organization_id,
    garage_id,
    service_id,
    promised_slot_at,
    actual_slot_at,
    days_later,
  }) => {
    analytics.capture({
      name: type,
      level: EventLevel.INFO,
      props: {
        organization_id,
        garage_id,
        service_id,
        promised_slot_at,
        actual_slot_at,
        days_later,
      },
    });
  },
);

bus.subscribe(
  EventType.RESULT_VIEWED,
  ({
    type,
    organization_name,
    organization_id,
    origin,
    service_partner_count,
    sort_method,
    service_slug,
    service_id,
    service_name,
    service_radius,
    vehicle_brand,
    vehicle_engine,
    vehicle_model,
    loading_time,
    distance_closest_service_partner,
    earliest_appointment,
    premium_services,
  }) => {
    analytics.capture({
      name: type,
      level: EventLevel.INFO,
      props: {
        organization_name,
        organization_id,
        origin,
        service_partner_count,
        sort_method,
        service_slug,
        service_id,
        service_name,
        service_radius,
        vehicle_brand,
        vehicle_engine,
        vehicle_model,
        loading_time,
        distance_closest_service_partner,
        earliest_appointment,
        premium_services,
      },
    });
  },
);
